const map = {
  skipFont: ({ theme }) => theme.fonts.set(`primary`, `semibold`),
  skipForeground: ({ theme }) => theme.colors.grasten,
  skipBackground: ({ theme }) => theme.colors.abla,
}

export default map
